/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable prettier/prettier */
import React from "react";
import { AppBar, Box, Container, Grid, Paper, Toolbar, Typography } from "@mui/material";
import { PRIMARY_COLOR, SECONDARY_COLOR } from "../consts/colors";
import { PRODUCTS } from "../consts/products";

export const HomeV2 = () => {

  const products = ["a", "b", "c", "d", "e", "f", "g", "h", "i", "j"]

  return (
    <div>
      <AppBar
        position="static"
        elevation={0}
        sx={{
          backgroundColor: PRIMARY_COLOR,
          color: SECONDARY_COLOR,
        }}
      >
        <Toolbar>
          <Typography variant="h4" sx={{ fontFamily: "Tenor Sans", textAlign: "center", flexGrow: 1, display: "flex", justifyContent: "center", }}>
            NIRAN
          </Typography>
        </Toolbar>
      </AppBar>
      
      <Container style={{ marginTop: "auto", marginLeft: "auto", marginRight: "auto" }}>

        <Box sx={{ display: "flex", flexDirection: ["column", "row"], justifyContent: "space-between", alignItems: "center", marginTop: "32px" }}>
          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "start" }}>
            <Typography variant="h4" sx={{ fontFamily: "Tenor Sans", textAlign: "start" }}>{"Catalogue"}</Typography>
            <Typography variant="h6" sx={{ fontFamily: "Tenor Sans", textAlign: "start" }}>{"A timeless luxuries passed down through the the ages"}</Typography>
          </Box>

          {/* filter button */}
          {/* <Box sx={{ width: "120px", height: "40px", backgroundColor: "black" }} /> */}
        </Box>

        

        <Box sx={{ height: 2, backgroundColor: "black", width: "100%", marginTop: "16px", marginBottom: "32px" }} />


        <Grid container spacing={4} justifyContent={"center"}>
          {PRODUCTS.map((product, index) => (
            <Grid item md={4} sm={6} xs={12} key={`product-${index}`} sx={{ marginBottom: 2 }}>
              
              <Box sx={{ width: "100%" }}>
                <img
                  style={{
                    width: "100%",
                    height: "auto",
                    objectFit: "cover",
                  }}
                  src={product.imageUrl}
                />
                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                  <Typography variant="h6" sx={{ fontFamily: "Tenor Sans", textAlign: "center" }}>{`${product.name}`}</Typography>
                  <Typography variant="h4" sx={{ fontFamily: "Tenor Sans", textAlign: "center" }}>{`Size ${product.size} | $${product.price}`}</Typography>
                </Box>

              </Box>
              
              {/* // <Box sx={{ backgroundColor: "yellow" }}>
              //   {product}
              // </Box> */}

            </Grid>
          ))}
        </Grid>
      </Container>
    </div>
  );
};
